import {
  Context,
  descending,
  entity,
  like,
  likeAny,
  notNull,
  query,
  some,
  string,
  truthy,
} from '~/prix'
import unaccent from '~/prix/functions/unaccent'

export default function AttendantListQuery(input: string, context: Context) {
  const normalizedInput = input.trim()
  const formattedInput = normalizedInput.replace(/\s+/g, '%')
  const isAgentUser = context.user?.roles.includes('agent')
  const agentName = context.user?.name ?? ''
  const agentCpf = context.user?.cpf ?? ''

  if (!isAgentUser && formattedInput.length > 0 && formattedInput.length < 3) {
    return query('legalEntityAttendanceAttendant')
      .select({
        hash: entity('legalEntityAttendanceAttendant').property('hash'),
        agentCpf: entity('legalEntityAttendanceAttendant').property('cpf'),
        name: entity('legalEntityAttendanceAttendant').property('coalesce'),
        order: entity('legalEntityAttendanceAttendant').property('endDate'),
        stateAbbreviation: entity('legalEntityAttendanceAttendant').property('stateAbbreviation'),
      })
      .where(
        like(
          entity('legalEntityAttendanceAttendant').property('cpf'),
          string().value('__no_match__'),
        ),
      )
      .limit(1)
  }

  const nameSearchTerm = isAgentUser ? `${agentName}%` : `${formattedInput}%`
  const cpfSearchTerm = isAgentUser ? `${agentCpf}%` : `${formattedInput}%`

  return query('legalEntityAttendanceAttendant')
    .join({
      current: entity('legalEntityAttendanceAttendant').property('cpf'),
      target: entity('attendant').property('cpf'),
      join: 'inner',
    })
    .select({
      hash: entity('legalEntityAttendanceAttendant').property('hash'),
      agentCpf: entity('legalEntityAttendanceAttendant').property('cpf'),
      name: entity('legalEntityAttendanceAttendant').property('coalesce'),
      order: entity('legalEntityAttendanceAttendant').property('endDate'),
      stateAbbreviation: entity('legalEntityAttendanceAttendant').property('stateAbbreviation'),
    })
    .where(
      ...[
        some(notNull(entity('attendant').property('serviceArea'))),
        some(
          like(
            unaccent(entity('legalEntityAttendanceAttendant').property('name')),
            unaccent(string().value(nameSearchTerm)),
          ),
          like(
            entity('legalEntityAttendanceAttendant').property('cpf'),
            string().value(cpfSearchTerm),
          ),
        ),
        context.user?.roles.includes('stateManager') && context.user.stateAbbreviation
          ? likeAny(string().value(context.user.stateAbbreviation), [
              entity('legalEntityAttendanceAttendant').property('stateAbbreviation') as any,
            ])
          : null,
      ].filter(truthy),
    )
    .order(descending('order'))
    .limit(20)
}
